var render = function render(){var _vm=this,_c=_vm._self._c;return _c('authStepsLayout',{attrs:{"step":_vm.step}},[_c('register',{ref:"register",on:{"step":function($event){_vm.step = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }